import { Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { MsalGuard } from '@azure/msal-angular';
import { MainLayoutComponent } from './layout/main-layout/main-layout';
// import { DashboardComponent } from './features/dashboard/dashboard/dashboard';
// import { WizardRematriculaComponent } from './features/pre-matricula/wizard-rematricula/wizard-rematricula.component';
import { Perfil } from './features/perfil/perfil';
import { Matriculas } from './features/matriculas/matriculas';
import { Home } from './features/home/home';
import { DesempenhoAcademicoComponent } from './features/avaliacoes/desempenho-academico/desempenho-academico';
import { FinanceiroComponent } from './features/financeiro/financeiro';
import { LoginComponent } from './login/login';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: ':escola',
    // redirectTo: 'home',
    component: MainLayoutComponent,
    // canActivate: [MsalGuard],
    children: [
      // {
      //   path: '',
      //   component: LoginComponent,
      //   // canActivate: [MsalGuard]
      // },
      // {
      //   path: 'login',
      //   component: LoginComponent
      // },

      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
        // component: Home,
      },
      {
        path: 'home',
        component: Home,
        // canActivate: [MsalGuard]
      },
      // {
      //   path: 'dashboard',
      //   component: DashboardComponent,
      //   canActivate: [MsalGuard]
      // },
      {
        path: 'matriculas',
        component: Matriculas,
        // canActivate: [MsalGuard]
      },
      {
        path: 'perfil',
        component: Perfil,
        // canActivate: [MsalGuard]
      },
      {
        path: 'avaliacoes',
        component: DesempenhoAcademicoComponent,
        // canActivate: [MsalGuard]
      },
      {
        path: 'financeiro',
        component: FinanceiroComponent,
        // canActivate: [MsalGuard]
      },
      // {
      //   path: 'pre-matricula/nova/:matriculaId',
      //   component: WizardRematriculaComponent,
      //   canActivate: [MsalGuard]
      // },
      // {
      //   path: 'pre-matricula/nova',
      //   component: WizardRematriculaComponent,
      //   canActivate: [MsalGuard]
      // },
      // {
      //   path: '',
      //   redirectTo: 'home',
      //   pathMatch: 'full'
      // },
    ]
  },
  {
    path: '',
    redirectTo: ':escola',
    pathMatch: 'full'
  },
  // {
  //   path: '**',
  //   redirectTo: '/default/home'
  // }
];

